import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import {Signals} from "@/Imports";
import TweenMax from "gsap";
import Utils from "@base/utils/Utils";
import Config from "../config/Config";

export default class StarContainer extends BaseContainer {

  constructor() {
    super()
    this.init()
  }

  init(data) {
    this.colors = [0x87f3ff, 0xdbd7b4, 0xdaf4f7, 0xb4ccdb, 0xf2f5f7]
    Signals.roundStart.add(this.start, this)
    Signals.roundEnd.add(this.stop, this)
    this.limit = Config.currentPattern ? Config.currentPattern.mainMask.width : 2300
    this.createItem()
  }

  createItem() {
    this.r = 0.1 + Math.random() * 2
    this.generateSpeed()
    if(Math.random() < 0.1 && this.r < 1) {
      this.blinking()
    } else {
      clearTimeout(this.blinkingTimeout)
    }
    let a = this.r > 2 ? 0.6 : 1
    this.g = new PIXI.Graphics()
    this.g.beginFill(this.colors[Utils.getRandomInt(0, this.colors.length - 1)], a)
    this.g.drawCircle(0, 0, this.r)
    this.g.endFill()
    this.addChild(this.g)

    this.obj = {
      speed: this.speed
    }
  }

  move() {
    this.x -= this.obj.speed
    if(this.x < 0) {
      this.redraw()
      this.x = this.limit
    }
  }

  redraw() {
    this.r = 0.1 + Math.random() * 2
    this.generateSpeed()
    if(Math.random() < 0.1 && this.r < 1) {
      this.blinking()
    } else {
      clearTimeout(this.blinkingTimeout)
    }
    let a = this.r > 2 ? 0.6 : 1

    this.g.clear()
    this.g.beginFill(this.colors[Utils.getRandomInt(0, this.colors.length - 1)], a)
    this.g.drawCircle(0, 0, this.r)
    this.g.endFill()
  }

  start() {
    TweenMax.to(this.obj, 7, {speed: this.speed, ease: Expo.easeIn})
  }

  stop() {
    TweenMax.killTweensOf(this.obj)
    this.obj = {
      speed: 0
    }
  }

  generateSpeed() {
    this.speed = ((this.r + Math.random()) - this.r) / 3;
  }

  blinking() {
    this.alpha = this.alpha == 1 ? 0.7 : 1
    this.blinkingTimeout = setTimeout(() => {
      this.blinking()
    }, 10 + Math.random() * 100)
  }


}
